import React from "react";
import {
  LuBot,
  LuClipboardList,
  LuCloud,
  LuCode,
  LuDownload,
  LuFlame,
  LuFolderOpen,
  LuGraduationCap,
  LuInfo,
  LuLineChart,
  LuMessageSquare,
  LuPackage,
  LuPieChart,
  LuSparkles,
  LuStar,
  LuTarget,
  LuTrophy,
  LuUsers,
  LuWand2,
  LuScissors,
  LuBeaker,
  LuCompass,
  LuTerminal,
  LuBarChart,
  LuClock,
  LuBuilding2,
  LuRefreshCw,
} from "react-icons/lu";

const ICON_MAP = {
  clipboard: LuClipboardList,
  dataset: LuClipboardList,
  cube: LuPackage,
  extensions: LuPackage,
  downloads: LuDownload,
  publishers: LuUsers,
  rating: LuStar,
  concentration: LuPieChart,
  building: LuBuilding2,
  flame: LuFlame,
  folder: LuFolderOpen,
  info: LuInfo,
  clock: LuClock,
  target: LuTarget,
  trophy: LuTrophy,
  bars: LuBarChart,
  chart: LuLineChart,
  chat: LuMessageSquare,
  bot: LuBot,
  cloud: LuCloud,
  academic: LuGraduationCap,
  snippets: LuScissors,
  formatter: LuWand2,
  lab: LuBeaker,
  compass: LuCompass,
  terminal: LuTerminal,
  sparkle: LuSparkles,
  code: LuCode,
  refresh: LuRefreshCw,
};

export default function Icon({
  name = "info",
  label,
  size = 18,
  className = "",
  color,
  ...rest
}) {
  const Component = ICON_MAP[name] || ICON_MAP.info;
  return (
    <Component
      size={size}
      color={color}
      className={`app-icon ${className}`.trim()}
      aria-label={label}
      role={label ? "img" : "presentation"}
      aria-hidden={label ? undefined : true}
      focusable="false"
      {...rest}
    />
  );
}
